<script setup lang="ts">
import { computed, ref } from 'vue'
import { map } from 'lodash'
import useSupport from '@/store/support'
import BSelect from '@/components/BSelect.vue'
import BIcon from '@/components/BIcon.vue'
import type { User } from '@/types/support'

const support = useSupport()

const collapsed = ref(false)
const currentUser = computed(() => support.supportUser)
const show = computed(() => Boolean(support.supportUser))
const options = computed(() =>
    map(support.users, (user: User) => ({
        value: user.id,
        label: `${user.firstName} ${user.lastName} (${user.username})`
    }))
)
const currentUsername = computed(() => options.value.find(option => option.value === currentUser.value)?.label)

const input = (event: Event) => {
    support.impersonate((event.target as HTMLSelectElement).value)
}
</script>

<template>
    <div
        v-if="show && !collapsed"
        class="sticky top-0 flex items-center gap-2 bg-primary !p-1">
        <BIcon
            icon="user"
            class="h-4 w-4 text-white" />

        <BSelect
            :model-value="currentUser"
            :options="options"
            block
            class="!h-6 shrink border-white !bg-primary !py-0 text-sm text-white focus:border-white focus:shadow-none"
            @input="input" />

        <BIcon
            icon="chevron-right"
            class="h-[1.5rem] w-[1.5rem] cursor-pointer rounded-full bg-white/25 p-1 text-white"
            @click="collapsed = true" />
    </div>
    <div
        v-else-if="show && collapsed"
        class="fixed right-0 top-0 z-50 flex items-center gap-2 rounded-bl-lg bg-primary p-[0.5rem]"
        @click="collapsed = false">
        <BIcon
            icon="chevron-left"
            class="h-[1.1rem] w-[1.1rem] cursor-pointer rounded-full bg-white/25 p-1 text-white" />

        <div class="text-xs font-bold text-white">
            {{ currentUsername ?? 'Show Support Toolbar' }}
        </div>
    </div>
</template>
